import { PLATFORMS } from '../../constants/platforms';

const PLATFORM_META = PLATFORMS.reduce((acc, p) => { acc[p.value] = p; return acc; }, {});

const PlatformPreviewCard = ({ platform, content, settings }) => {
  const meta = PLATFORM_META[platform] || {};
  const Icon = meta.icon;

  return (
    <div className={`card border-l-4 ${meta.borderColor || 'border-gray-400'}`}>
      <div className="flex items-center gap-2 mb-3">
        {Icon && <Icon className={`w-5 h-5 ${meta.color || 'text-gray-600'}`} />}
        <span className="font-medium text-gray-900 dark:text-white">{meta.label || platform}</span>
        {renderBadge(platform, settings)}
      </div>

      <div className="space-y-1 text-sm text-gray-700 dark:text-gray-300">
        <p className="font-medium">{content?.title}</p>
        {renderPlatformPreview(platform, content, settings)}
      </div>
    </div>
  );
};

function renderBadge(platform, settings) {
  let label = null;
  if (platform === 'YOUTUBE' && settings?.privacyStatus) {
    label = settings.privacyStatus;
  } else if (platform === 'TIKTOK' && settings?.privacyLevel) {
    label = settings.privacyLevel.replace(/_/g, ' ').toLowerCase();
  }
  if (!label) return null;
  return (
    <span className="ml-auto px-2 py-0.5 text-xs rounded-full bg-gray-100 dark:bg-dark-700 text-gray-600 dark:text-gray-400 capitalize">
      {label}
    </span>
  );
}

function renderPlatformPreview(platform, content, settings) {
  switch (platform) {
    case 'YOUTUBE':
      return (
        <>
          {content?.description && <p className="text-xs text-gray-500 line-clamp-2">{content.description}</p>}
          {settings?.madeForKids && <span className="text-xs text-amber-600">Made for Kids</span>}
        </>
      );
    case 'TIKTOK':
      return content?.description && <p className="text-xs text-gray-500 line-clamp-2">{content.description}</p>;
    case 'INSTAGRAM':
      return (
        <p className="text-xs text-gray-500 line-clamp-3">
          {settings?.captionOverride || [content?.title, content?.description, content?.hashtags].filter(Boolean).join(' ')}
        </p>
      );
    case 'TWITTER':
      return (
        <p className="text-xs text-gray-500 line-clamp-3">
          {settings?.tweetTextOverride || [content?.title, content?.description].filter(Boolean).join(' ')}
        </p>
      );
    case 'FACEBOOK':
      return content?.description && <p className="text-xs text-gray-500 line-clamp-2">{content.description}</p>;
    default:
      return null;
  }
}

export default PlatformPreviewCard;
